'use strict';

import Loader from '../loader/loader';
import { isFieldEmpty, isFieldSame, displayErrors, isDobEmpty, isValidDob, autofocusDob } from '../../_assets/abbott/js/_helper';
import { toaster } from '../../_assets/abbott/js/_material';

export default class UpdateDetails {
    constructor() {
        let $body = $('body'),
            $updateDetailsDropdown = $('.update-details__dropdown').not('.my-profile'),
            $hcpId = $('#HcpId'),
            $hcpViewReturnUrl = $('#HcpViewReturnUrl'),
            $hcpWorkplaceId = $('#HcpWorkplaceId'),
            $updateForm = $('#update-hcpdetails-form'),
            loader = new Loader(),
            //Reset password//
            $pwUserId = $('#HensId'),
            $pwNewPassword = $('#UpdatePassword'),
            $pwVerifyPassword = $('#UpdateVerifyPassword'),
            $pwDropdown = $('.update-password__dropdown'),
            $frmResetPswd = $('#hcp-reset-password-form'),
            //////////////////
            dateCheck,
            _isInvalid = [],
            dataParams = {},
            dobParams;

        $('.js-expand-details').on('click', function (e) {
            e.preventDefault();

            $updateDetailsDropdown.slideDown({
                duration: 500,
                easing: 'easeOutExpo',
                queue: false,
                complete: function () {
                    $body.addClass('fixed');
                }
            });
        });

        //autofocus on DOB inputs
        autofocusDob();


        $('.js-hpc-update-password').on('click', function (e) {
            e.preventDefault();

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            _isInvalid = [];

            if (isFieldEmpty($pwNewPassword) || !isFieldSame($pwNewPassword, $pwVerifyPassword))
            {
                $pwVerifyPassword
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                $(this).removeClass('error');
                loader.fadeIn();

                dataParams = {
                    'UserId': $pwUserId.val(),
                    'NewPassword': $pwNewPassword.val(),
                    'ConfirmNewPassword': $pwVerifyPassword.val()
                };

                $.ajax({
                    url: '/api/account/resetpassword',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'PUT',
                    headers: {__RequestVerificationToken: $frmResetPswd.find('input[name=__RequestVerificationToken]').val()},
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Password has been updated!');
                        window.location.reload();
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });
                    },
                    error: function (error) {
                        loader.fadeOut();
                        displayErrors(error, $errorContainer);
                    }
                });
            }
        });


        //hcp-details page update dropdown
        $('.js-update-hcp-details').on('click', function (e) {
            e.preventDefault();
            let $firstName = $updateDetailsDropdown.find('#UpdateFirstName'),
                $lastName = $updateDetailsDropdown.find('#UpdateLastName'),
                $dobDay = $updateDetailsDropdown.find('#HcpDobDay'),
                $dobMonth = $updateDetailsDropdown.find('#HcpDobMonth'),
                $dobYear = $updateDetailsDropdown.find('#HcpDobYear'),
                $gender = $updateDetailsDropdown.find('#UpdateGender'),
                $mobileNumber = $updateDetailsDropdown.find('#UpdateMobileNumber'),
                $emailAddress = $updateDetailsDropdown.find('#UpdateEmailAddress');

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            var phoneRegEx = /^[0-9]{8,10}$/;

            _isInvalid = [];

            if (isFieldEmpty($firstName)) {
                $firstName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($lastName)) {
                $lastName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }


            if (!isFieldEmpty($mobileNumber) && !$mobileNumber.val().match(phoneRegEx)) {
                $mobileNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                $(this).removeClass('error');
                loader.fadeIn();

                dobParams = $dobDay.val() == '' && $dobMonth.val() == '' && $dobYear.val() == '' ? null :
                    {
                        'Day': $dobDay.val(),
                        'Month': $dobMonth.val(),
                        'Year': $dobYear.val()
                    };

                dataParams = {
                    'HcpId': $hcpId.val(),
                    'Details': {
                        'FirstName': $firstName.val(),
                        'LastName': $lastName.val(),
                        'Dob': dobParams,
                        'Gender': $gender.val(),
                        'MobileNumber': $mobileNumber.val() == '' ? null : $mobileNumber.val(),
                        'EmailAddress': $emailAddress.val()
                    }
                };

                $.ajax({
                    url: '/api/hcps/updatedetails',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'PUT',
                    headers: {__RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val()},
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Details have been saved!');
                        window.location.reload();
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $('.js-collapse-details').trigger('click');
                    },
                    error: function (error) {

                        loader.fadeOut();
                        displayErrors(error, $errorContainer);
                    }
                });
            }
        });

        $('.js-update-my-details').on('click', function (e) {
            e.preventDefault();
            let $myFirstName = $('#UpdateFirstName'),
                $myLastName = $('#UpdateLastName'),
                $myDobDay = $('#DobDay'),
                $myDobMonth = $('#DobMonth'),
                $myDobYear = $('#DobYear'),
                $myGender = $('#UpdateGender'),
                $myMobileNumber = $('#UpdateMobileNumber'),
                $myHcpId = $('#MyHcpId'),
                $emailAddress = $('#UpdateEmailAddress');

            // Define where to display ajax errors
            let $errorContainer = $(this).parent().siblings('.server-errors__wrap');

            var phoneRegEx = /^[0-9]{8,10}$/;

            _isInvalid = [];

            if (isFieldEmpty($myFirstName)) {
                $myFirstName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isFieldEmpty($myLastName)) {
                $myLastName
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }


            if (!isFieldEmpty($myMobileNumber) && !$myMobileNumber.val().match(phoneRegEx)) {
                $myMobileNumber
                    .parent().addClass('incomplete')
                    .find('.error').slideDown({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }

            if (isValidDob() || isDobEmpty()) {
                $myDobDay.parent().removeClass('incomplete');
                $myDobMonth.parent().removeClass('incomplete');
                $myDobYear.parent().removeClass('incomplete');

                $('.dob .error').fadeOut({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

            } else {
                $myDobDay.parent().addClass('incomplete');
                $myDobMonth.parent().addClass('incomplete');
                $myDobYear.parent().addClass('incomplete');

                $('.dob .error').fadeIn({
                    duration: 500,
                    easing: 'easeOutExpo',
                    queue: false
                });

                _isInvalid.push(0);
            }


            if (_isInvalid.length > 0) {
                $(this).addClass('error');
                return false;
            } else {
                _isInvalid = [];

                $(this).removeClass('error');
                loader.fadeIn();

                dobParams = $myDobDay.val() == '' && $myDobMonth.val() == '' && $myDobYear.val() == '' ? null :
                    {
                        'Day': $myDobDay.val(),
                        'Month': $myDobMonth.val(),
                        'Year': $myDobYear.val()
                    };

                dataParams = {
                    'HcpId': $myHcpId.val(),
                    'Details': {
                        'FirstName': $myFirstName.val(),
                        'LastName': $myLastName.val(),
                        'Dob': dobParams,
                        'Gender': $myGender.val(),
                        'MobileNumber': $myMobileNumber.val() == '' ? null : $myMobileNumber.val(),
                        'EmailAddress': $emailAddress.val()
                    }
                };

                $.ajax({
                    url: '/api/hcps/updatedetails',
                    dataType: 'json',
                    contentType: 'application/json; charset=utf-8',
                    type: 'PUT',
                    headers: {__RequestVerificationToken: $updateForm.find('input[name=__RequestVerificationToken]').val()},
                    data: JSON.stringify(dataParams),
                    success: function (data) {
                        toaster('Details have been saved!');
                        window.location.reload();
                        loader.fadeOut();

                        $errorContainer.slideUp({
                            duration: 500,
                            easing: 'easeInOutExpo',
                            queue: false
                        });

                        $('.js-collapse-details').trigger('click');
                    },
                    error: function (error) {

                        loader.fadeOut();
                        displayErrors(error, $errorContainer);
                    }
                });
            }
        });
    }
}
